import { FC, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { useFetchErrorToast } from '../../utils/useFetchErrorToasts/useFetchErrorToast';
import Header from '../../common/Header/Header';
import {
  Page,
  TableWrapper,
} from '../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Table from '../../components/Table/Table';
import { useStoreInfo } from '../../services/StoreInfo/storeInfo.service';

const StoreInfo: FC = () => {

  const gridRef = useRef<AgGridReact>(null);
  const { data, isError: timesError } = useStoreInfo(true);

  useFetchErrorToast([{ isError: timesError, label: 'Error fetching StoreInfo', id: 'StoreInfoFetchError' }]);

  return (
    <>
      <Header breadcrumb={{ to: '/tables', label: 'All tables' }} title="Store & Store Market Info" titleTestId={'StoreInfoPageTitle'}/>
      <Page>
        <TableWrapper>
          <Table
            rowData={data?.data}
            ref={gridRef}
            returnedRecords={data?.data?.length}
            height={'100%'}
            width={'100%'}
            columnDefs={[
              { field: 'storeNo', headerName: 'Store No',flex:1 },
              {field: 'address', headerName: 'Address',flex:3},
              {field: 'city', headerName: 'City',tooltipValueGetter: (params) => params.value,flex:1 },
              { field: 'state', headerName: 'State' ,flex:1},
              { field: 'zip', headerName: 'Zip Code',flex:1 },
              { field: 'marketNo', headerName: 'Market',flex:1},
              { field: 'timeZone', headerName: 'Time Zone' ,flex:1},
              { field: 'conceptType', headerName: 'Concept',flex:1 },
              { field: 'phone', headerName: 'Phone' ,flex:1 ,tooltipValueGetter: (params) => params.value}
            ]}
          />
        </TableWrapper>
      </Page>
    </>
  );
};

export default StoreInfo;